import { IconButton } from "@material-ui/core";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  FaCaretDown,
  FaCaretUp,
  FaPauseCircle,
  FaPlayCircle,
} from "react-icons/fa";
import CommonMenu2 from "../../../Common/CommonMenu2";
import { useDispatch } from "react-redux";
import { setVideoPlayInformation } from "../../../Redux/Actions/IntercutVideoActions";
import { forwardRef } from "react";
import { useRef, useEffect } from "react";
import VideoPlayer from "./VideoPlayer";
const grid = 8;
const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: grid,
});
const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,
  background: isDragging ? "#47a1fb" : "white",
  ...draggableStyle,
});

const DragAndDropContainer = (
  {
    label,
    intercutVideoData,
    itemSelectionName,
    selectedItemType,
    isDragDisabled,
    handleOnDrag,
    selectedItem,
    handleItemSelection,
    shortText,
    menuItemContent,
    angleName,
    listName,
    singlePositionDrag,
  },
  menuRef
) => {
  const dispatch = useDispatch();
  const videoList =
    intercutVideoData?.interCutVideoList?.[angleName]?.[listName];
  const handleVideoEnd = () => {
    // Video has ended, update play information to paused
    setVideoPlayInformation(dispatch, {
      angleName: angleName,
      listName: listName,
      isPlaying: false,
      videoPath: intercutVideoData?.interCutVideoList?.[angleName]?.videoPath,
      playingIndex: null,
    });
  };

  return (
    <div className="grid-columns2 font-rajdhani bg-white">
      <div className="d-flex-center mg-bottom-10">
        <span className="bold fs-22">{label}</span>
      </div>
      <div className="">
        <VideoPlayer
          videoPath={
            intercutVideoData?.interCutVideoList?.[angleName]?.videoPath
          }
          isPlaying={
            intercutVideoData?.interCutVideoList?.[angleName]?.isPlaying
          }
          onEnded={handleVideoEnd}
        />
      </div>
      <div className="clear10"></div>
      <div
        className="d-flex-center brd-black-1"
        style={{ borderRadius: "7px" }}
      >
        <IconButton
          aria-label="delete"
          onClick={() => {
            singlePositionDrag(selectedItem, false, angleName, listName);
          }}
          className={`${
            selectedItemType && videoList?.length !== 1 && !isDragDisabled
              ? "dragDropBtn-active"
              : "dragDropBtn"
          }`}
          disabled={
            !selectedItemType || videoList.length === 1 || isDragDisabled
          }
        >
          <FaCaretDown className="white fs-22" />
        </IconButton>

        <IconButton
          aria-label="delete"
          onClick={() => {
            singlePositionDrag(selectedItem, true, angleName, listName);
          }}
          className={`${
            selectedItemType && videoList.length !== 1 && !isDragDisabled
              ? "dragDropBtn-active"
              : "dragDropBtn"
          }`}
          disabled={
            !selectedItemType || videoList.length === 1 || isDragDisabled
          }
        >
          <FaCaretUp className="white fs-22" />
        </IconButton>
      </div>
      <div className="clear10"></div>
      <div>
        <DragDropContext
          onDragEnd={(result) => handleOnDrag(result, angleName, listName)}
        >
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
                className="draggableTableContainer"
              >
                {videoList &&
                  videoList?.map((item, index) => (
                    <div>
                      <Draggable
                        key={item.id}
                        draggableId={item.id.toString()}
                        index={index}
                        isDragDisabled={isDragDisabled}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              background: `${
                                snapshot.isDragging ? "#002244" : "white"
                              }`,
                              color: `${
                                snapshot.isDragging || selectedItem === item
                                  ? "white"
                                  : "black"
                              }`,
                              ...snapshot.isDragging,
                              ...provided.draggableProps.style,
                            }}
                            className={`draggableTable mg-bottom-0 ${
                              selectedItem == item && "selectedVideoItem"
                            }`}
                            onClick={() =>
                              handleItemSelection(item, itemSelectionName)
                            }
                          >
                            <div className="d-flex-space-between w-100">
                              <div>
                                <div className="d-flex-align-cent">
                                  <div>
                                    {intercutVideoData?.interCutVideoList?.[
                                      angleName
                                    ]?.playingIndex != index && (
                                      <span>
                                        <FaPlayCircle
                                          onClick={() => {
                                            setVideoPlayInformation(dispatch, {
                                              angleName: angleName,
                                              listName: listName,
                                              isPlaying: true,
                                              videoPath: item.videoPath,
                                              playingIndex: index,
                                            });
                                          }}
                                          className="fs-40 mg-right-10"
                                        />
                                      </span>
                                    )}
                                    {intercutVideoData?.interCutVideoList?.[
                                      angleName
                                    ]?.playingIndex == index && (
                                      <span>
                                        <FaPauseCircle
                                          onClick={() => {
                                            setVideoPlayInformation(dispatch, {
                                              angleName: angleName,
                                              listName: listName,
                                              isPlaying: false,
                                              videoPath: item.videoPath,
                                              playingIndex: null,
                                            });
                                          }}
                                          className="fs-40 mg-right-10"
                                        />
                                      </span>
                                    )}
                                  </div>
                                  <div>
                                    {/* <span>
                                      {shortText(item.eventMediaCategory)}
                                    </span> */}
                                    <span>{item.eventMediaCategory}</span>
                                  </div>
                                </div>
                              </div>
                              <CommonMenu2
                                ref={menuRef}
                                menuContent={menuItemContent(
                                  item,
                                  angleName,
                                  listName
                                )}
                                rowData={item}
                                data={selectedItem ? selectedItem : null}
                                isIntercutPage={true}
                              />
                            </div>
                          </div>
                        )}
                      </Draggable>
                      {videoList?.length > 0 &&
                        index + 1 !== videoList?.length && (
                          <div className="clear5"></div>
                        )}
                    </div>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default forwardRef(DragAndDropContainer);
